export function dateToLocalDate(passedDate) {
    if (passedDate == null) {
        return null;
    }
    let date = new Date(passedDate);
    let month = date.getMonth() + 1;
    month = month.toString().length == 1 ? `0${month}` : month;
    let day = date.getDate();
    day = day.toString().length == 1 ? `0${day}` : day;
    let year = date.getFullYear();
    return [day, month, year].join(".");
}
export function dateToLocalDateTime(passedDate) {
    if (passedDate == null) {
        return null;
    }
    let date = new Date(passedDate);
    let month = date.getMonth() + 1;
    month = month.toString().length == 1 ? `0${month}` : month;
    let day = date.getDate();
    day = day.toString().length == 1 ? `0${day}` : day;
    let year = date.getFullYear();
    const formatedDate = [day, month, year].join(".");

    let hours = date.getHours();
    hours = hours.toString().length == 1 ? `0${hours}` : hours;
    let minutes = date.getMinutes();
    minutes = minutes.toString().length == 1 ? `0${minutes}` : minutes;

    return `${formatedDate}, ${hours}:${minutes}`;
}
export function integerToTime(int) {
    let timeObject = {
        hours: 0,
        minutes: 0,
    };

    var hours = int / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    timeObject.hours = rhours;
    timeObject.minutes = rminutes;

    return timeObject;
}
export function dateToTimestamp(date) {
    let myDate = date.split("T")[0].split("-");

    let myTime = date
        .split("T")[1]
        .split(".")[0]
        .split(":");
    let newDate = new Date(
        parseInt(myDate[0]),
        parseInt(myDate[1]) - 1,
        parseInt(myDate[2]),
        parseInt(myTime[0]),
        parseInt(myTime[1]),
        parseInt(myTime[2])
    );
    return newDate.getTime();
}
